import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'ef-discount-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
  template: `
    <div
      class="md:h-full lg:w-[600px] aspect-[347/450] bg-[url(assets/empikfoto/images/discount_banner_background.webp)] bg-cover bg-center flex flex-col justify-between"
    >
      <div class="flex flex-col gap-4 bg-purple-1 text-white p-4 md:p-6"
        ><p
          class="text-heading-05-normal md:text-heading-04-normal"
          [innerHTML]="'discount_banner_header_text' | translate"
        ></p
        ><p class="text-[3.5rem]/[3.5rem] font-bold md:text-[4.5rem]">{{
          'discount_banner_discount_value' | translate
        }}</p></div
      >
      <div class="py-4 md:py-6 text-body-03">
        <p class="text-center" [innerHTML]="'discount_banner_info_text' | translate"></p>
      </div>
    </div>
  `,
})
export class EfDiscountBannerComponent {}
